import { useMemo } from "react";
import { useSelector } from "react-redux";
import { usePermissions } from "../acl/usePermission";
import type { PermissionCheckRequest } from "../api/aclApi";
import type { ComponentWithSource } from "../api/componentsData";
import { EMPTY_ARRAY } from "@/constants/reduxStableRefs";

export function useCreatableCollections(enabled = true) {
  const components = useSelector(
    (state: any) => state.components?.data ?? EMPTY_ARRAY
  ) as ComponentWithSource[];

  const permissionRequests = useMemo<PermissionCheckRequest[]>(() => {
    return components
      .filter((component) => component?.uid)
      .map((component) => ({
        action: "create" as const,
        targetType: "collection" as const,
        targetId: component.uid!,
      }));
  }, [components]);

  const { results, loading } = usePermissions(permissionRequests, {
    enabled: enabled && permissionRequests.length > 0,
  });

  const creatableCollections = useMemo(() => {
    if (loading || permissionRequests.length === 0) {
      return [] as ComponentWithSource[];
    }
    let resultIndex = 0;
    return components.filter((component) => {
      if (!component?.uid) return false;
      const allowed = results[resultIndex]?.allowed === true;
      resultIndex += 1;
      return allowed;
    });
  }, [components, loading, permissionRequests.length, results]);

  const hasCreatableCollections = creatableCollections.length > 0;

  return { creatableCollections, hasCreatableCollections, loading };
}
